import { render, staticRenderFns } from "./widget_support_tickets.vue?vue&type=template&id=20e47df5&"
import script from "./widget_support_tickets.vue?vue&type=script&lang=js&"
export * from "./widget_support_tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports